var _g, _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2621_2457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 0H2V29H31V0Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.41602 7.85425H28.5827V22.3542H4.41602V7.85425Z",
    stroke: "#0E2483",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41602 12.6876C7.08539 12.6876 9.24935 10.5236 9.24935 7.85425H4.41602V12.6876Z",
    stroke: "#0E2483",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41602 17.5208C7.08539 17.5208 9.24935 19.6847 9.24935 22.3541H4.41602V17.5208Z",
    stroke: "#0E2483",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5833 17.5208V22.3541H23.75C23.75 19.6847 25.9139 17.5208 28.5833 17.5208Z",
    stroke: "#0E2483",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5833 12.6876C25.9139 12.6876 23.75 10.5236 23.75 7.85425H28.5833V12.6876Z",
    stroke: "#0E2483",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4993 18.7292C18.1677 18.7292 19.5202 17.1063 19.5202 15.1042C19.5202 13.1022 18.1677 11.4792 16.4993 11.4792C14.831 11.4792 13.4785 13.1022 13.4785 15.1042C13.4785 17.1063 14.831 18.7292 16.4993 18.7292Z",
    stroke: "#0E2483",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.4,
    cy: 19.4,
    r: 5.4,
    fill: "white",
    stroke: "#0E2483",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.48047 17.48L8.32047 21.32",
    stroke: "#0E2483",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32031 17.48L4.48031 21.32",
    stroke: "#0E2483",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2621_2457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white",
    transform: "translate(2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.5cda5cd59b2e92405380b48e1fcea2ac.svg";
export { ForwardRef as ReactComponent };